import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SystemsService } from './systems.service';

export interface AuthRequest {
  username: string;
  password: string;
}

export interface AuthResponse {
  message: string;
  session: {
    id: number;
    user: string;
    token: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenKey = 'auth_token';
  private usernameKey = 'username';
  private userIdKey = 'user_id';
  //private userModulesKey = 'user_modules';

  constructor(
    private http: HttpClient,
    private systemsService: SystemsService
  ) {}

  login(credentials: AuthRequest): Observable<AuthResponse> {
    const url = `${environment.apiUrl}/app/auth/valid`;
    return this.http.post<AuthResponse>(url, credentials).pipe(
      tap(response => {
        const { id, user, token } = response.session;
        if (token) {
          localStorage.setItem(this.tokenKey, token);
          localStorage.setItem(this.usernameKey, user);
          localStorage.setItem(this.userIdKey, id.toString()); 

          //this.loadUserModules(id);
        }
      }),
      catchError(error => {
        console.error('Login error:', error);
        const message = error?.error?.message || 'Credenciales incorrectas o servicio no disponible.';
        return throwError(() => new Error(message));
      })
    );
  }

  /*private loadUserModules(userId: number) {
    this.systemsService.getModulesByUser(userId).subscribe({
      next: (modules) => {
        this.setUserModules(modules);
      },
      error: (err) => {
        console.error('Error al cargar módulos del usuario:', err);
      }
    });
  }

  setUserModules(modules: any[]) {
    localStorage.setItem(this.userModulesKey, JSON.stringify(modules));
  }*/

  getUserId(): number | null {
    const id = localStorage.getItem(this.userIdKey);
    return id ? Number(id) : null;
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  getUsername(): string | null {
    return localStorage.getItem(this.usernameKey);
  }

  /*getUserModules(): any[] {
    const modules = localStorage.getItem(this.userModulesKey);
    return modules ? JSON.parse(modules) : [];
  }*/

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.usernameKey);
    localStorage.removeItem(this.userIdKey);     
    //localStorage.removeItem(this.userModulesKey); 
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}